import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BooleanFilter } from '@models/filter-types';

export const CONFIRM_DIALOG = 'confirm';
export const DENY_DIALOG = 'deny';
const CLOSE_DIALOG = 'close';
export const CANCEL_DIALOG = 'cancel';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false,
})
export class ConfirmDialogComponent implements OnInit {
    constructor(
        private dialogRef: MatDialogRef<unknown>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            text: string;
            warningText?: string;
            autoConfirm: boolean;
            noClickClose: boolean;
            confirmText: string;
            destructiveConfirm?: boolean;
            denyText: string;
            denyClose: boolean;
            showCancel?: boolean;
            cancelText?: string;
            toggleProperty?: BooleanFilter;
        },
    ) {
        dialogRef.disableClose = !data.noClickClose;
    }

    ngOnInit(): void {
        if (this.data.autoConfirm) {
            this.onConfirm();
        }
    }

    onConfirm() {
        this.dialogRef.close(CONFIRM_DIALOG);
    }

    onDeny() {
        this.dialogRef.close(DENY_DIALOG);
    }

    onClose() {
        this.dialogRef.close(this.data.denyClose === true ? DENY_DIALOG : CLOSE_DIALOG);
    }

    onCancel() {
        this.dialogRef.close(CANCEL_DIALOG);
    }
}
